<template>
  <div v-if="activeBanners.length > 0" class="top-banner" :style="{ background: currentBanner.bgColor || '#3182f6' }">
    <div class="banner-wrapper">
      <transition name="slide" mode="out-in">
        <router-link 
          v-if="currentBanner.link" 
          :to="currentBanner.link" 
          :key="currentIndex"
          class="banner-content"
        >
          <p>{{ currentBanner.text }}</p>
        </router-link>
        <p v-else :key="currentIndex" class="banner-content">{{ currentBanner.text }}</p>
      </transition>
    </div>

    <!-- 인디케이터 (2개 이상일 때) -->
    <div v-if="activeBanners.length > 1" class="banner-indicators">
      <button 
        v-for="(_, index) in activeBanners" 
        :key="index"
        class="indicator"
        :class="{ active: currentIndex === index }"
        @click="goToSlide(index)"
      />
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore'
import { db } from '@/services/firebase'

export default {
  name: 'TopBanner',
  setup() {
    const banners = ref([])
    const currentIndex = ref(0)
    let interval = null

    const activeBanners = computed(() => {
      return banners.value.filter(b => b.isActive)
    })

    const currentBanner = computed(() => {
      return activeBanners.value[currentIndex.value] || {}
    })

    const fetchBanners = async () => {
      try {
        const q = query(
          collection(db, 'topBanners'),
          where('isActive', '==', true),
          orderBy('order', 'asc')
        )
        const snapshot = await getDocs(q)
        banners.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
      } catch (e) {
        console.error('탑배너 로드 실패:', e)
      }
    }

    const nextBanner = () => {
      if (activeBanners.value.length > 1) {
        currentIndex.value = (currentIndex.value + 1) % activeBanners.value.length
      }
    }

    const goToSlide = (index) => {
      currentIndex.value = index
      stopAutoPlay()
      startAutoPlay()
    }

    const startAutoPlay = () => {
      interval = setInterval(nextBanner, 4000)
    }

    const stopAutoPlay = () => {
      if (interval) clearInterval(interval)
    }

    onMounted(async () => {
      await fetchBanners()
      if (activeBanners.value.length > 1) {
        startAutoPlay()
      }
    })

    onUnmounted(() => {
      stopAutoPlay()
    })

    return {
      activeBanners,
      currentBanner,
      currentIndex,
      goToSlide
    }
  }
}
</script>

<style scoped>
.top-banner {
  position: relative;
  padding: 12px 24px;
  text-align: center;
  transition: background 0.3s;
}

.banner-wrapper {
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.banner-content p {
  margin: 0;
}

a.banner-content:hover {
  text-decoration: underline;
}

/* 슬라이드 애니메이션 */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* 인디케이터 */
.banner-indicators {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 6px;
}

.indicator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s;
}

.indicator.active {
  background: #fff;
  width: 16px;
  border-radius: 3px;
}

@media (max-width: 768px) {
  .top-banner {
    padding: 10px 16px;
  }

  .banner-content {
    font-size: 13px;
  }

  .banner-indicators {
    display: none;
  }
}
</style>